import React, { useEffect, useRef } from 'react';

import { IMcsaMeshConfig, MCSA_WELCOME_MESH, mountMcsaMesh } from '../../../helpers/mcsa-mesh.helper';

interface MeshBackgroundProps {
    config?: IMcsaMeshConfig;
}

export const MeshBackground = (props: MeshBackgroundProps) => {
    const { config = MCSA_WELCOME_MESH } = props;

    const rootRef = useRef<HTMLDivElement>(null);
    const fallbackRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) return;

        return mountMcsaMesh(root, fallbackRef.current, config);
    }, [config]);

    return (
        <div className='mcsa_mesh_bg' ref={rootRef} aria-hidden='true'>
            <div className='mcsa_mesh_bg__fallback' ref={fallbackRef} />
            <div className='mcsa_mesh_bg__overlay' />
        </div>
    );
};
